"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Type;
(function (Type) {
    Type["Slot"] = "slot";
    Type["Newest"] = "newest";
    Type["Trending"] = "trending";
    Type["RecentlyViewed"] = "latest";
    Type["AlsoViewed"] = "viewed";
    Type["AlsoBought"] = "bought";
    Type["FrequentlyPurchasedTogether"] = "purchasedTogether";
    Type["Featured"] = "featured";
})(Type = exports.Type || (exports.Type = {}));
//# sourceMappingURL=Recommendations.js.map